import { useEffect, useState } from "react";
import logo from "@/assets/uvashop-logo.webp";

const KEY = "age_verified";

export default function AgeGate() {
  const [status, setStatus] = useState("loading"); // loading | ask | denied | ok

  useEffect(() => {
    setStatus(localStorage.getItem(KEY) === "yes" ? "ok" : "ask");
  }, []);

  useEffect(() => {
    const lock = status === "ask" || status === "denied";
    document.body.style.overflow = lock ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [status]);

  const confirm = () => { localStorage.setItem(KEY, "yes"); setStatus("ok"); };

  if (status === "loading" || status === "ok") return null;

  return (
    <div role="dialog" aria-modal="true" aria-label="Verifica dell'età" className="fixed inset-0 z-[100] bg-ink text-bone flex items-center justify-center px-6" data-testid="age-gate">
      <div className="max-w-lg text-center">
        <img src={logo} alt="UvaShop" width="749" height="186" className="h-9 w-auto mx-auto mb-8" />
        {status === "ask" ? (
          <>
            <h1 className="font-serif-display text-5xl leading-tight mb-6">Hai compiuto 18 anni?</h1>
            <p className="text-bone/60 mb-10 leading-relaxed">
              Per accedere a questo sito devi essere maggiorenne. La vendita e la somministrazione di bevande alcoliche ai minori di 18 anni è vietata dalla legge.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button data-testid="age-confirm" onClick={confirm} className="bg-claret hover:bg-claret-dark text-bone px-10 min-h-[48px] uppercase tracking-[0.15em] text-sm transition-colors">Sì, ho 18 anni o più</button>
              <button data-testid="age-deny" onClick={() => setStatus("denied")} className="border border-bone/30 hover:border-bone px-10 min-h-[48px] uppercase tracking-[0.15em] text-sm transition-colors">No</button>
            </div>
          </>
        ) : (
          <>
            <h1 className="font-serif-display text-4xl leading-tight mb-6">Accesso non consentito</h1>
            <p className="text-bone/60 mb-8 leading-relaxed">Ci dispiace, devi avere almeno 18 anni per accedere a UvaShop.</p>
            <button data-testid="age-back" onClick={() => setStatus("ask")} className="underline text-bone/70 text-sm hover:text-bone transition-colors">Torna indietro</button>
          </>
        )}
        <p className="mt-12 text-xs text-bone/70 uppercase tracking-[0.25em]">Bevi responsabilmente</p>
      </div>
    </div>
  );
}
